<template>
  <v-card>
    <v-card-title>
      Notification List
    </v-card-title>

    <v-divider />

    <v-container class="pa-0">
      <v-data-table
        height="calc(100vh - 230px)"
        :headers="headers"
        :items="notifications"
        :loading="isLoading"
        :server-items-length="pagination.total"
        :footer-props="{ disablePagination: isLoading }"
        item-key="notification_id"
        show-expand
        fixed-header
        single-expand
        @pagination="$emit('pagination', $event)"
      >
        <template #expanded-item="{item}">
          <td :colspan="headers.length + 1" style="padding: 0">
            <v-list class="expanded-notification-info">
              <v-list-item
                v-for="(value, key) in item.message"
                :key="key"
              >
                <fieldset class="rounded-8 notification-fields mb-3">
                  <legend class="ml-4 px-2" v-text="upperFirst(key)" />

                  <v-card-title class="pt-1 pb-1" v-text="upperFirst(value.header)" />
                  <v-card-text v-if="value.excerpt" class="pb-1" v-html="$sanitize(value.excerpt)" />
                  <v-card-text class="pt-1" v-html="$sanitize(value.content)" />
                </fieldset>
              </v-list-item>
            </v-list>
          </td>
        </template>
      </v-data-table>
    </v-container>
  </v-card>
</template>

<script>
  import { upperFirst } from 'lodash'

  export default {
    props: {
      isLoading: Boolean,
      notifications: {
        type: Array,
        default: () => ([])
      },
      pagination: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        headers: [
          { text: 'ID', value: 'notification_id', sortable: false },
          { text: 'Created', value: 'created', sortable: false },
          { text: 'Event name', value: 'event_name', sortable: false },
          { text: 'Status', value: 'status', sortable: false },
        ],
        notificationFields: [ 'header', 'excerpt', 'content' ]
      }
    },
    methods: {
      upperFirst
    }
  }
</script>

<style lang="scss" scoped>
  .expanded-notification-info {

    fieldset {
      border: thin solid rgba(0, 0, 0, 0.35);
    }

    .notification-fields {
      width: 100%;

      .v-card:not(:last-child) {
        margin-bottom: 1rem;
      }
    }
  }
</style>
